import { useState } from 'react';

import CheckIcon from '@common/assets/icons/check.svg?react';
import { BottomSheet } from '@common/ui/BottomSheet';
import { Button } from '@common/ui/buttons/Button';
import { Cell } from '@common/ui/Cell';
import { Separator } from '@common/ui/Separator';

export interface DeleteAccountDialogProps {
  onDelete: (reason: string) => void;
  onCancel: () => void;
}

export const DeleteAccountDialog = ({
  onDelete,
  onCancel,
}: DeleteAccountDialogProps) => {
  const [reason, setReason] = useState<string>();

  const checkIcon = (
    <CheckIcon style={{ color: 'var(--graphic-action-primary)' }} />
  );

  const buttons: React.ReactNode[] = [];

  if (reason) {
    buttons.push(
      <Button
        testId="delete-account-confirm"
        variant="negativeSecondary"
        onClick={() => onDelete(reason)}
      >
        Удалить
      </Button>,
    );
  }

  buttons.push(
    <Button
      testId="delete-account-cancel-button"
      variant="actionSecondary"
      onClick={onCancel}
    >
      Отмена
    </Button>,
  );

  return (
    <BottomSheet
      image="/icons/3d-icons/sad.png"
      title="Удалить аккаунт?"
      subtitle="Вы не сможете его восстановить.<br/><br/>Расскажите, почему решили удалить?"
      buttons={buttons}
      data-test-id="delete-account-dialog"
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: 32,
        }}
      >
        <Cell
          testId="delete-account-reason-cant-find"
          title="Не могу никого найти"
          onClick={() => setReason('cant_find')}
          separator={<Separator />}
          suffixIcon={reason === 'cant_find' && checkIcon}
        />
        <Cell
          testId="delete-account-reason-few-profiles"
          title="Мало анкет"
          onClick={() => setReason('few_profiles')}
          separator={<Separator />}
          suffixIcon={reason === 'few_profiles' && checkIcon}
        />
        <Cell
          testId="delete-account-reason-expensive-subscription"
          title="Дорогая подписка"
          onClick={() => setReason('expensive_subscription')}
          separator={<Separator />}
          suffixIcon={reason === 'expensive_subscription' && checkIcon}
        />
        <Cell
          testId="delete-account-reason-bugs"
          title="Постоянные ошибки или баги"
          onClick={() => setReason('bugs')}
          separator={<Separator />}
          suffixIcon={reason === 'bugs' && checkIcon}
        />
        <Cell
          testId="delete-account-reason-bored"
          title="Надоело"
          onClick={() => setReason('bored')}
          separator={<Separator />}
          suffixIcon={reason === 'bored' && checkIcon}
        />
      </div>
    </BottomSheet>
  );
};
